/* tslint:disable */
/* eslint-disable */
/**
 * cellera-backend API spec
 * Backend Service for Cellera | [swagger.json](cellera/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PatientsPaginationRequestDto
 */
export interface PatientsPaginationRequestDto {
    /**
     * Search term for Email, Name, Phone
     * @type {string}
     * @memberof PatientsPaginationRequestDto
     */
    search?: string;
    /**
     * Filter by gender (can be single or multiple values)
     * @type {Array<string>}
     * @memberof PatientsPaginationRequestDto
     */
    gender?: Array<PatientsPaginationRequestDtoGenderEnum>;
    /**
     * Filter by status (can be single or multiple values)
     * @type {Array<string>}
     * @memberof PatientsPaginationRequestDto
     */
    status?: Array<PatientsPaginationRequestDtoStatusEnum>;
    /**
     * Filter by birth date from (YYYY-MM-DD)
     * @type {Date}
     * @memberof PatientsPaginationRequestDto
     */
    birthDateFrom?: Date;
    /**
     * Filter by birth date to (YYYY-MM-DD)
     * @type {Date}
     * @memberof PatientsPaginationRequestDto
     */
    birthDateTo?: Date;
    /**
     * Sort by field
     * @type {string}
     * @memberof PatientsPaginationRequestDto
     */
    sortBy?: PatientsPaginationRequestDtoSortByEnum;
    /**
     * Sort order
     * @type {string}
     * @memberof PatientsPaginationRequestDto
     */
    sortOrder?: PatientsPaginationRequestDtoSortOrderEnum;
    /**
     * Page number (1-based)
     * @type {number}
     * @memberof PatientsPaginationRequestDto
     */
    page?: number;
    /**
     * Number of items per page
     * @type {number}
     * @memberof PatientsPaginationRequestDto
     */
    pageSize?: number;
    /**
     * Check if patients exist in provider's contact list
     * @type {boolean}
     * @memberof PatientsPaginationRequestDto
     */
    existedInContactList?: boolean;
}


/**
 * @export
 */
export const PatientsPaginationRequestDtoGenderEnum = {
    Male: 'male',
    Female: 'female',
    Other: 'other',
    Unknown: 'unknown'
} as const;
export type PatientsPaginationRequestDtoGenderEnum = typeof PatientsPaginationRequestDtoGenderEnum[keyof typeof PatientsPaginationRequestDtoGenderEnum];

/**
 * @export
 */
export const PatientsPaginationRequestDtoStatusEnum = {
    Requesting: 'requesting',
    ActiveSharing: 'active_sharing',
    Revoked: 'revoked'
} as const;
export type PatientsPaginationRequestDtoStatusEnum = typeof PatientsPaginationRequestDtoStatusEnum[keyof typeof PatientsPaginationRequestDtoStatusEnum];

/**
 * @export
 */
export const PatientsPaginationRequestDtoSortByEnum = {
    Email: 'email',
    Name: 'name',
    Phone: 'phone',
    RequestedDate: 'requestedDate'
} as const;
export type PatientsPaginationRequestDtoSortByEnum = typeof PatientsPaginationRequestDtoSortByEnum[keyof typeof PatientsPaginationRequestDtoSortByEnum];

/**
 * @export
 */
export const PatientsPaginationRequestDtoSortOrderEnum = {
    Asc: 'ASC',
    Desc: 'DESC'
} as const;
export type PatientsPaginationRequestDtoSortOrderEnum = typeof PatientsPaginationRequestDtoSortOrderEnum[keyof typeof PatientsPaginationRequestDtoSortOrderEnum];


/**
 * Check if a given object implements the PatientsPaginationRequestDto interface.
 */
export function instanceOfPatientsPaginationRequestDto(value: object): value is PatientsPaginationRequestDto {
    return true;
}

export function PatientsPaginationRequestDtoFromJSON(json: any): PatientsPaginationRequestDto {
    return PatientsPaginationRequestDtoFromJSONTyped(json, false);
}

export function PatientsPaginationRequestDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): PatientsPaginationRequestDto {
    if (json == null) {
        return json;
    }
    return {
        
        'search': json['search'] == null ? undefined : json['search'],
        'gender': json['gender'] == null ? undefined : json['gender'],
        'status': json['status'] == null ? undefined : json['status'],
        'birthDateFrom': json['birthDateFrom'] == null ? undefined : (new Date(json['birthDateFrom'])),
        'birthDateTo': json['birthDateTo'] == null ? undefined : (new Date(json['birthDateTo'])),
        'sortBy': json['sortBy'] == null ? undefined : json['sortBy'],
        'sortOrder': json['sortOrder'] == null ? undefined : json['sortOrder'],
        'page': json['page'] == null ? undefined : json['page'],
        'pageSize': json['pageSize'] == null ? undefined : json['pageSize'],
        'existedInContactList': json['existedInContactList'] == null ? undefined : json['existedInContactList'],
    };
}

export function PatientsPaginationRequestDtoToJSON(json: any): PatientsPaginationRequestDto {
    return PatientsPaginationRequestDtoToJSONTyped(json, false);
}

export function PatientsPaginationRequestDtoToJSONTyped(value?: PatientsPaginationRequestDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'search': value['search'],
        'gender': value['gender'],
        'status': value['status'],
        'birthDateFrom': value['birthDateFrom'] == null ? undefined : ((value['birthDateFrom']).toISOString()),
        'birthDateTo': value['birthDateTo'] == null ? undefined : ((value['birthDateTo']).toISOString()),
        'sortBy': value['sortBy'],
        'sortOrder': value['sortOrder'],
        'page': value['page'],
        'pageSize': value['pageSize'],
        'existedInContactList': value['existedInContactList'],
    };
}

